import React, { useState, useEffect } from 'react';
import Datatables from '../DataTable/Datatables';
import Button from 'react-bootstrap/Button';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Axios } from '../components/common/Axios';
import { FaTrashAlt, FaEdit } from 'react-icons/fa';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import Form from 'react-bootstrap/Form';
import { useForm } from 'react-hook-form';
import Swal from "sweetalert2";
import { notify, notifyErr } from '../components/common/norify';


const Thankyou = () => {

  const apiUrl = process.env.REACT_APP_API_URL;

  const [data, setData] = useState([]);
  const [pending, setPending] = useState(true);
  const [id, setId] = useState('')

  const getData = async () => {
    try {
      const thankyouData = await Axios.get('/api/thankyou');
      let thankyou = thankyouData.data.data;
      setData(thankyou);

    } catch (error) {
      // Handle errors
      console.error('Error:', error);
    } finally {
      setPending(false)
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const tableData = {
    columns: [
      {
        name: <th className='fs-6 ' >#</th>,
        cell: (row, index) => index + 1,
        width: '100px',
      },
      {
        name: <th className='fs-6 '>Heading</th>,
        selector: (row) => row.heading,
        width: '240px',
      },
      {
        name: <th className='fs-6 '>Content</th>,
        selector: (row) => row.content,
        width: '250px',
      },
      {
        name: <th className='fs-6'>Media</th>,
        selector: (row) => (
          <>
            {row.media && <img width="60px" height="60px" className='p-2' src={`${apiUrl}/static/assets/${row.media}`} alt="Thankyou Image" />}
            {/* {row.media && <video width="60px" height="60px" className='p-2' src={`${apiUrl}/static/assets/${row.media}`} alt="Portfolio Image" />} */}
          </>
        ),
        width: '150px',
      },
      {
        name: <th className='fs-6'>Action</th>,
        selector: (row) => (
          <div className='d-flex' style={{ gap: '10px' }}>
            <Link to={`/thankyou-update/${row._id}`}>
              <Button className='Add_btn_ text-white' variant='contained' style={{ float: 'right', backgroundColor: '#0C0833' }}>
                <FaEdit />
              </Button>
            </Link>

          </div>
        ),
        right: true,
        width: '250px',

      },
    ],
  };


  // const handleDelete = async (id) => {
  //   try {
  //     const response = await Axios.delete(`/api/service/${id}`);
  //     Swal.fire({
  //       title: 'Deleted!',
  //       text: 'Your data has been deleted.',
  //       icon: 'success',
  //       confirmButtonColor: '#0C0833',
  //     });
  //   } catch (error) {
  //     console.error(error);
  //     notifyErr('Something went wrong!')
  //     Swal.fire({
  //       title: 'Error',
  //       text: 'An error occurred while deleting the data.',
  //       icon: 'error',
  //     });
  //   }
  // };

  // const confirmDelete = (id) => {
  //   Swal.fire({
  //     title: 'Are you sure to Delete?',
  //     text: "You won't be able to revert this!",
  //     icon: 'warning',
  //     showCancelButton: true,
  //     confirmButtonColor: '#0C0833',
  //     cancelButtonColor: 'grey',
  //     confirmButtonText: 'Yes, delete it!',
  //   }).then((result) => {
  //     if (result.value) {
  //       handleDelete(id);
  //     }
  //   });
  // };


  return (
    <>
      <div className='thankyou-page'>
        <Helmet>
          <title>Thankyou</title>
        </Helmet>

        <section id="main-content" style={pending ? { opacity: '0.5' } : { opacity: '1' }}>
          <ToastContainer />
          <section className="wrapper _blogs">
            <div className="row">
              <div className="col-lg-6">
                <span className='p-3 fw-bold'>Thankyou</span>
              </div>

              <div className='col-lg-6 pb-2 btn-d d-flex justify-content-end'>
                {/* <Link to="/service-add">
                  <Button className='Add_btn_ text-white' variant='contained' style={{ float: 'right' }} >
                    Add Service
                  </Button>
                </Link> */}

              </div>
            </div>
          </section>

        </section>

        <section className=' mt-2'>
          <Card >
            <div className="main " >
              <Datatables data={data} columns={tableData.columns} />
            </div>
          </Card>

        </section>


      </div>
    </>
  )
}

export default Thankyou